import React, { useEffect, useState } from 'react'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { editSupplyOrderUserAPI } from '../../../../../api/supply/supplyOrderAPI'
import SupplierUsersSelectMain from '../../../../form/fields/SupplierUsersSelectMain'
import { addSupplyOrderUser } from '../../../../../store/supplyOrderSlice'
import { useDispatch } from 'react-redux'

const UserInSupplyOrderForm = ({ supplyOrderId, userBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(userBd ? {userId: userBd.id} : {}) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()

        setError('')
        setLoading(true)

        editSupplyOrderUserAPI({
            supplyOrderId, userId: data.userId
        }).then(data => {
            dispatch(addSupplyOrderUser(data))
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('userId', 'supplyOrderUser') ?
				<SupplierUsersSelectMain
					required={formDataProductRequiredField('userId', 'supplyOrderUser')}
					setValidate={e => updateValidate(setValid, 'userId', e)}
					setValueForm={e => setValueForm(setData, 'userId', e)}
					forciblyValue={data && data.userId ? data.userId : ''}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default UserInSupplyOrderForm